import axios from "axios";
import { Form, Toolbar } from "devextreme-react";
import { GroupItem, Label, SimpleItem } from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../utils/hasPermission";
import { PERM } from "../../../utils/permissions";

export default function ProjectAssignment(props) {
  const [dataSource, setDataSource] = useState({
    MWManagerDataSource: null,
    MWDataSource: null,
    COManagerDataSource: null,
    CPMDataSource: null,
    CRADataSource: null,
    CTADataSource: null,
    DMManagerDataSource: null,
    DMDataSource: null,
    DPMDataSource: null,
    DRMDataSource: null,
    SAManagerDataSource: null,
    SADataSource: null,
    SPDataSource: null,
    PVManagerDataSource: null,
    PVADataSource: null,
    QAManagerDataSource: null,
    QAADataSource: null,
    RAManagerDataSource: null,
    RAADataSource: null,
    DDataSource: null,
    MDataSource: null,
    S1DataSource: null,
    S2DataSource: null,
    JDataSource: null,
  });
  // const [MWManagerDataSource, setMWManagerDataSource] = useState(null);
  // const [MWDataSource, setMWDataSource] = useState(null);

  // const [COManagerDataSource, setCOManagerDataSource] = useState(null);
  // const [CPMDataSource, setCPMDataSource] = useState(null);
  // const [CRADataSource, setCRADataSource] = useState(null);
  // const [CTADataSource, setCTADataSource] = useState(null);

  // const [DMManagerDataSource, setDMManagerDataSource] = useState(null);
  // const [DPMDataSource, setDPMDataSource] = useState(null);
  // const [DRMDataSource, setDRMDataSource] = useState(null);

  // const [SAManagerDataSource, setSAManagerDataSource] = useState(null);
  // const [SADataSource, setSADataSource] = useState(null);
  // const [SPDataSource, setSPDataSource] = useState(null);

  // const [PVManagerDataSource, setPVManagerDataSource] = useState(null);
  // const [PVADataSource, setPVADataSource] = useState(null);

  // const [QAManagerDataSource, setQAManagerDataSource] = useState(null);
  // const [QAADataSource, setQAADataSource] = useState(null);

  // const [RAManagerDataSource, setRAManagerDataSource] = useState(null);
  // const [RAADataSource, setRAADataSource] = useState(null);

  const { contrNo } = props;

  // const [formData, setFormData] = useState(null);
  // const [roleList, setRoleList] = useState(null);
  const [projectAssign, setProjectAssign] = useState({
    roleList: null,
    formData: null,
  });

  const userInfo = useSelector((state) => state.userInfo);
  const canAssignMW = hasPermission(userInfo.permissions, PERM.PRJ_ASSIGN_MW);
  const canAssignCO = hasPermission(userInfo.permissions, PERM.PRJ_ASSIGN_CO);
  const canAssignDM = hasPermission(userInfo.permissions, PERM.PRJ_ASSIGN_DM);
  const canAssignSA = hasPermission(userInfo.permissions, PERM.PRJ_ASSIGN_SA);
  const canAssignPV = hasPermission(userInfo.permissions, PERM.PRJ_ASSIGN_PV);
  const canAssignQA = hasPermission(userInfo.permissions, PERM.PRJ_ASSIGN_QA);
  const canAssignRA = hasPermission(userInfo.permissions, PERM.PRJ_ASSIGN_RA);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/employee?tenure=1`)
      .then((result) => {
        setDataSource({
          MWManagerDataSource: new DataSource({
            store: result.data.filter(
              (employee) => employee.jd == "Head of MW"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          MWDataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "MW"),
            key: "employeeNo",
            group: "jd",
          }),
          COManagerDataSource: new DataSource({
            store: result.data.filter(
              (employee) => employee.jd == "Head of CO"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          CPMDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "CPM" || employee.jd == "PM" ||
                (employee.div == "CO" && employee.canBeAMgr == "1")
            ),
            key: "employeeNo",
            group: "jd",
          }),
          CRADataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "CO"),
            key: "employeeNo",
            group: "jd",
          }),
          CTADataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "CO"),
            key: "employeeNo",
            group: "jd",
          }),
          DMManagerDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "Head of DM" ||
                (employee.div == "DM" && employee.canBeAMgr == "1")
            ),
            key: "employeeNo",
            group: "jd",
          }),
          DMDataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "DM"),
            key: "employeeNo",
            group: "jd",
          }),
          DPMDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "DPM" ||
                employee.jd == "Head of DM" ||
                employee.jd == "DRM"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          DRMDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "DRM" ||
                employee.jd == "Head of DM" ||
                employee.jd == "DPM"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          SAManagerDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "Head of SA" || employee.jd == "STAT.M" ||
                (employee.div == "SA" && employee.canBeAMgr == "1")
            ),
            key: "employeeNo",
            group: "jd",
          }),
          SADataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                // employee.jd == "SA" ||
                employee.jd == "STAT" ||
                employee.jd == "SP" ||
                employee.jd == "Head of SA"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          SPDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "SP" ||
                employee.jd == "Head of SA" ||
                employee.jd == "STAT"
              // employee.jd == "SA"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          PVManagerDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "Head of PV" ||
                (employee.div == "PV" && employee.canBeAMgr == "1")
            ),
            key: "employeeNo",
            group: "jd",
          }),
          PVADataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "PV"),
            key: "employeeNo",
            group: "jd",
          }),
          QAManagerDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "Head of QA" ||
                (employee.div == "QA" && employee.canBeAMgr == "1")
            ),
            key: "employeeNo",
            group: "jd",
          }),
          QAADataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "QA"),
            key: "employeeNo",
            group: "jd",
          }),
          RAManagerDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "Head of RA" ||
                (employee.div == "RA" && employee.canBeAMgr == "1")
            ),
            key: "employeeNo",
            group: "jd",
          }),
          RAADataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "RA"),
            key: "employeeNo",
            group: "jd",
          }),
          DDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "Head of RA" ||
                (employee.div == "RA" && employee.canBeAMgr == "1") ||
                employee.jd == "Head of MW"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          MDataSource: new DataSource({
            store: result.data.filter(
              (employee) =>
                employee.jd == "Head of RA" ||
                (employee.div == "RA" && employee.canBeAMgr == "1") ||
                employee.jd == "Head of MW"
            ),
            key: "employeeNo",
            group: "jd",
          }),
          S1DataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "RA"),
            key: "employeeNo",
            group: "jd",
          }),
          S2DataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "RA"),
            key: "employeeNo",
            group: "jd",
          }),
          JDataSource: new DataSource({
            store: result.data.filter((employee) => employee.div == "RA"),
            key: "employeeNo",
            group: "jd",
          }),
        });
      });
  }, []);

  useEffect(() => {
    if (contrNo) {
      // setFormData(null);
      setProjectAssign({
        roleList: null,
        formData: null,
      });

      // axios
      //   .get(
      //     `${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt/roleList/${contrNo}`
      //   )
      //   .then((result) => {
      //     console.debug("result of roleList", result.data);

      //     setRoleList(result.data.role.split(","));
      //   });

      axios
        .get(`${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt/${contrNo}`)
        .then((result) => {
          const formData = {};
          for (const [role, members] of Object.entries(result.data.formData || {})) {
            // dxForm treats a dot as a nested path; retain the literal API role separately.
            const field = role === "STAT.M" ? "STAT_M" : role;
            formData[field] = members ? members.split(",") : [];
          }
          setProjectAssign({
            formData,
            roleList: (result.data.roleList?.role || "").split(",").filter(Boolean),
          });
        });
    }
  }, [contrNo]);

  const onValueChanged = async (previousValues, newValues, role) => {
    previousValues = Array.isArray(previousValues) ? previousValues : [];
    newValues = Array.isArray(newValues) ? newValues : [];
    const assignedMember = newValues.filter(
      (value) => !previousValues.includes(value)
    );

    if (assignedMember.length > 0) {
      await axios.post(
        `${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt/${contrNo}/${role}`,
        {
          employeeNo: assignedMember,
        }
      );
    }

    const unassignedMember = previousValues.filter(
      (value) => !newValues.includes(value)
    );

    if (projectAssign.formData && unassignedMember.length > 0) {
      await axios.put(
        `${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt/${contrNo}/${role}`,
        {
          employeeNo: unassignedMember.join(),
        }
      );
    }
  };

  const onMWManagerValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "MW Manager");
    onValueChanged(e.previousValue, e.value, "MWM");
  };

  const onMWValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "MW");
    onValueChanged(e.previousValue, e.value, "MWA");
  };

  const onCOManagerValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "CO Manager");
    onValueChanged(e.previousValue, e.value, "CRM");
  };

  const onCPMValueChanged = async (e) => {
    // const previousValues = e.previousValue;
    // const newValues = e.value;

    // console.debug("previousValues", previousValues);
    // console.debug("newValues", newValues);

    // console.debug(
    //   "assigned",
    //   newValues.filter((value) => !previousValues.includes(value))
    // );
    // console.debug(
    //   "unassigned",
    //   previousValues.filter((value) => !newValues.includes(value))
    // );

    onValueChanged(e.previousValue, e.value, "CPM");

    // if (formData && previousValues.length == 0 && newValues == formData.CPM) {
    //   console.debug("INIT");
    // } else {
    // const assignedMember = newValues.filter(
    //   (value) => !previousValues.includes(value)
    // );

    // console.debug("[assignedMember]", assignedMember);

    // if (assignedMember.length > 0) {
    //   await axios.post(
    //     `${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt/${contrNo}/CPM`,
    //     {
    //       employeeNo: assignedMember,
    //     }
    //   );
    // }

    // const unassignedMember = previousValues.filter(
    //   (value) => !newValues.includes(value)
    // );

    // console.debug("[unassignedMember]", unassignedMember);

    // if (projectAssign.formData && unassignedMember.length > 0) {
    //   await axios.put(
    //     `${process.env.REACT_APP_BECCO_API_URL}/api/prjAsgmt/${contrNo}/CPM`,
    //     {
    //       employeeNo: unassignedMember.join(),
    //     }
    //   );
    // }
    // }
  };

  const onCRAValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "CRA");
  };

  const onCTAValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "CTA");
    onValueChanged(e.previousValue, e.value, "SSU");
  };

  const onDMManagerValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "DM Manager");
    onValueChanged(e.previousValue, e.value, "DMM");
  };

  const onDPMValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "DPM");
  };

  const onDRMValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "DRM");
  };

  const onSAManagerValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "SA Manager");
    onValueChanged(e.previousValue, e.value, "SAM");
  };

  const onSAValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "SA");
    onValueChanged(e.previousValue, e.value, "SASP");
  };

  const onSPValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "SP");
  };

  const onPVManagerValueChanged = async (e) => {
    //   onValueChanged(e.previousValue, e.value, "PV Manager");
    onValueChanged(e.previousValue, e.value, "PVM");
  };

  const onPVAValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "PVA");
  };

  const onQAManagerValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "QA Manager");
    onValueChanged(e.previousValue, e.value, "QAM");
  };

  const onQAAValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "QAA");
  };

  const onRAManagerValueChanged = async (e) => {
    // onValueChanged(e.previousValue, e.value, "RA Manager");
    onValueChanged(e.previousValue, e.value, "RAM");
  };

  const onRAAValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "RAA");
  };

  const onDValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "D");
  };

  const onMValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "M");
  };

  const onS1ValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "S1");
  };

  const onS2ValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "S2");
  };

  const onJValueChanged = async (e) => {
    onValueChanged(e.previousValue, e.value, "J");
  };

  const displayExpr = (item) => {
    if (item) {
      return `${item.name} (${item.employeeNo})`;
    } else {
      return null;
    }
  };

  const itemRender = ({ employeeNo, name }) => {
    return (
      <div>
        {name} ({employeeNo})
      </div>
    );
  };

  const roleItem = (role, source, allowed) =>
    projectAssign.roleList.includes(role) && (
      <SimpleItem
        key={role}
        dataField={role === "STAT.M" ? "STAT_M" : role}
        editorType="dxTagBox"
        editorOptions={{
          dataSource: source,
          valueExpr: "employeeNo",
          searchEnabled: true,
          grouped: true,
          displayExpr,
          showSelectionControls: true,
          showClearButton: true,
          applyValueMode: "useButtons",
          readOnly: !allowed,
          itemRender,
          onValueChanged: (e) => onValueChanged(e.previousValue, e.value, role),
        }}
      >
        <Label text={role} alignment="right" />
      </SimpleItem>
    );

  return (
    <React.Fragment>
      <div id="projectAssignment">
        <Toolbar>
          <Item location="before">
            <span style={{ fontWeight: 500, color: "#009688" }}>
              PROJECT MEMBERS{contrNo ? `: ${contrNo}` : ``}
            </span>
          </Item>
        </Toolbar>
        {projectAssign && projectAssign.roleList?.length > 0 && (
          <Form
            labelMode="outside"
            showColonAfterLabel={false}
            labelLocation={"left"}
            minColWidth={300}
            formData={projectAssign.formData}
          >
            {/* {(projectAssign.roleList.includes("MW Manager") || */}
            {(projectAssign.roleList.includes("MWM") ||
              // projectAssign.roleList.includes("MW")) && (
              projectAssign.roleList.includes("MWA")) && (
              <GroupItem cssClass={"MW"}>
                {/* {projectAssign.roleList.includes("MW Manager") && ( */}
                {projectAssign.roleList.includes("MWM") && (
                  <SimpleItem
                    // dataField={"MW Manager"}
                    dataField={"MWM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.MWManagerDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignMW,
                      itemRender: itemRender,
                      onValueChanged: onMWManagerValueChanged,
                    }}
                  >
                    {/* <Label text={"MW Manager"} alignment={"right"} /> */}
                    <Label text={"MWM"} alignment={"right"} />
                  </SimpleItem>
                )}
                {/* {projectAssign.roleList.includes("MW") && ( */}
                {projectAssign.roleList.includes("MWA") && (
                  <SimpleItem
                    // dataField={"MW"}
                    dataField={"MWA"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.MWDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignMW,
                      itemRender: itemRender,

                      onValueChanged: onMWValueChanged,
                    }}
                  >
                    {/* <Label text="MW" alignment={"right"} /> */}
                    <Label text="MWA" alignment={"right"} />
                  </SimpleItem>
                )}
              </GroupItem>
            )}

            {/* {(projectAssign.roleList.includes("CO Manager") || */}
            {(projectAssign.roleList.includes("CRM") ||
              projectAssign.roleList.includes("CPM") ||
              projectAssign.roleList.includes("PM") ||
              projectAssign.roleList.includes("CRA") ||
              // projectAssign.roleList.includes("CTA")) && (
              projectAssign.roleList.includes("SSU")) && (
              <GroupItem cssClass={"CO"}>
                {/* {projectAssign.roleList.includes("CO Manager") && ( */}
                {projectAssign.roleList.includes("CRM") && (
                  <SimpleItem
                    // dataField={"CO Manager"}
                    dataField={"CRM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.COManagerDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignCO,
                      itemRender: itemRender,

                      onValueChanged: onCOManagerValueChanged,
                    }}
                  >
                    {/* <Label text="CO Manager" alignment={"right"} /> */}
                    <Label text="CRM" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("CPM") && (
                  <SimpleItem
                    dataField={"CPM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.CPMDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignCO,
                      itemRender: itemRender,

                      onValueChanged: onCPMValueChanged,
                    }}
                  >
                    <Label text="CPM" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("CRA") && (
                  <SimpleItem
                    dataField={"CRA"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.CRADataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignCO,
                      itemRender: itemRender,

                      onValueChanged: onCRAValueChanged,
                    }}
                  >
                    <Label text="CRA" alignment={"right"} />
                  </SimpleItem>
                )}
                {/* {projectAssign.roleList.includes("CTA") && ( */}
                {projectAssign.roleList.includes("SSU") && (
                  <SimpleItem
                    // dataField={"CTA"}
                    dataField={"SSU"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.CTADataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignCO,
                      itemRender: itemRender,

                      onValueChanged: onCTAValueChanged,
                    }}
                  >
                    {/* <Label text="CTA" alignment={"right"} /> */}
                    <Label text="SSU" alignment={"right"} />
                  </SimpleItem>
                )}
                {roleItem("PM", dataSource.CPMDataSource, canAssignCO)}
              </GroupItem>
            )}

            {/* {(projectAssign.roleList.includes("DM Manager") ||
              projectAssign.roleList.includes("DPM") ||
              projectAssign.roleList.includes("DRM")) && ( */}
            {(projectAssign.roleList.includes("DMM") ||
              projectAssign.roleList.includes("DPM") ||
              projectAssign.roleList.includes("DRM") ||
              projectAssign.roleList.includes("CDA") ||
              projectAssign.roleList.includes("DMA")) && (
              <GroupItem cssClass={"DM"}>
                {/* {projectAssign.roleList.includes("DM Manager") && ( */}
                {projectAssign.roleList.includes("DMM") && (
                  <SimpleItem
                    // dataField={"DM Manager"}
                    dataField={"DMM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.DMManagerDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignDM,
                      itemRender: itemRender,

                      onValueChanged: onDMManagerValueChanged,
                    }}
                  >
                    {/* <Label texst="DM Manager" alignment={"right"} /> */}
                    <Label text="DMM" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("DPM") && (
                  <SimpleItem
                    dataField={"DPM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.DPMDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignDM,
                      itemRender: itemRender,

                      onValueChanged: onDPMValueChanged,
                    }}
                  >
                    <Label text="DPM" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("DRM") && (
                  <SimpleItem
                    dataField={"DRM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.DRMDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignDM,
                      itemRender: itemRender,

                      onValueChanged: onDRMValueChanged,
                    }}
                  >
                    <Label text="DRM" alignment={"right"} />
                  </SimpleItem>
                )}
                {roleItem("CDA", dataSource.DMDataSource, canAssignDM)}
                {roleItem("DMA", dataSource.DMDataSource, canAssignDM)}
              </GroupItem>
            )}

            {/* {(projectAssign.roleList.includes("SA Manager") ||
              projectAssign.roleList.includes("SA") ||
              projectAssign.roleList.includes("SP")) && ( */}
            {(projectAssign.roleList.includes("SAM") ||
              projectAssign.roleList.includes("SASP") ||
              projectAssign.roleList.includes("STAT.M") ||
              projectAssign.roleList.includes("STAT")) && (
              <GroupItem cssClass={"SA"}>
                {/* {projectAssign.roleList.includes("SA Manager") && ( */}
                {projectAssign.roleList.includes("SAM") && (
                  <SimpleItem
                    // dataField={"SA Manager"}
                    dataField={"SAM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.SAManagerDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignSA,
                      itemRender: itemRender,

                      onValueChanged: onSAManagerValueChanged,
                    }}
                  >
                    {/* <Label texst="SA Manager" alignment={"right"} /> */}
                    <Label text="SAM" alignment={"right"} />
                  </SimpleItem>
                )}
                {/* {projectAssign.roleList.includes("SA") && ( */}
                {projectAssign.roleList.includes("SASP") && (
                  <SimpleItem
                    // dataField={"SA"}
                    dataField={"SASP"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.SADataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignSA,
                      itemRender: itemRender,

                      onValueChanged: onSAValueChanged,
                    }}
                  >
                    <Label text="SASP" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("SP") && (
                  <SimpleItem
                    dataField={"SP"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.SPDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignSA,
                      itemRender: itemRender,

                      onValueChanged: onSPValueChanged,
                    }}
                  >
                    <Label text="SP" alignment={"right"} />
                  </SimpleItem>
                )}
                {roleItem("STAT.M", dataSource.SAManagerDataSource, canAssignSA)}
                {roleItem("STAT", dataSource.SADataSource, canAssignSA)}
              </GroupItem>
            )}

            {/* {(projectAssign.roleList.includes("PV Manager") || */}
            {(projectAssign.roleList.includes("PVM") ||
              projectAssign.roleList.includes("PVA")) && (
              <GroupItem cssClass={"PV"}>
                {/* {projectAssign.roleList.includes("PV Manager") && ( */}
                {projectAssign.roleList.includes("PVM") && (
                  <SimpleItem
                    // dataField={"PV Manager"}
                    dataField={"PVM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.PVManagerDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignPV,
                      itemRender: itemRender,

                      onValueChanged: onPVManagerValueChanged,
                    }}
                  >
                    {/* <Label texst="PV Manager" alignment={"right"} /> */}
                    <Label text="PVM" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("PVA") && (
                  <SimpleItem
                    dataField={"PVA"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.PVADataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignPV,
                      itemRender: itemRender,

                      onValueChanged: onPVAValueChanged,
                    }}
                  >
                    <Label text="PVA" alignment={"right"} />
                  </SimpleItem>
                )}
              </GroupItem>
            )}
            {/* {(projectAssign.roleList.includes("QA Manager") || */}
            {(projectAssign.roleList.includes("QAM") ||
              projectAssign.roleList.includes("QAA")) && (
              <GroupItem cssClass={"QA"}>
                {/* {projectAssign.roleList.includes("QA Manager") && ( */}
                {projectAssign.roleList.includes("QAM") && (
                  <SimpleItem
                    // dataField={"QA Manager"}
                    dataField={"QAM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.QAManagerDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignQA,
                      itemRender: itemRender,

                      onValueChanged: onQAManagerValueChanged,
                    }}
                  >
                    {/* <Label texst="QA Manager" alignment={"right"} /> */}
                    <Label text="QAM" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("QAA") && (
                  <SimpleItem
                    dataField={"QAA"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.QAADataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignQA,
                      itemRender: itemRender,

                      onValueChanged: onQAAValueChanged,
                    }}
                  >
                    <Label text="QAA" alignment={"right"} />
                  </SimpleItem>
                )}
              </GroupItem>
            )}

            {/* {(projectAssign.roleList.includes("RA Manager") || */}
            {(projectAssign.roleList.includes("RAM") ||
              projectAssign.roleList.includes("RAA")) && (
              <GroupItem cssClass={"RA"}>
                {/* {projectAssign.roleList.includes("RA Manager") && ( */}
                {projectAssign.roleList.includes("RAM") && (
                  <SimpleItem
                    // dataField={"RA Manager"}
                    dataField={"RAM"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.RAManagerDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignRA,
                      itemRender: itemRender,

                      onValueChanged: onRAManagerValueChanged,
                    }}
                  >
                    {/* <Label texst="RA Manager" alignment={"right"} /> */}
                    <Label text="RAM" alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("RAA") && (
                  <SimpleItem
                    dataField={"RAA"}
                    editorType="dxTagBox"
                    editorOptions={{
                      dataSource: dataSource.RAADataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      // displayExpr: "name",
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignRA,
                      itemRender: itemRender,

                      onValueChanged: onRAAValueChanged,
                    }}
                  >
                    <Label text="RAA" alignment={"right"} />
                  </SimpleItem>
                )}
              </GroupItem>
            )}
            {(projectAssign.roleList.includes("D") ||
              projectAssign.roleList.includes("J") ||
              projectAssign.roleList.includes("M") ||
              projectAssign.roleList.includes("S1") ||
              projectAssign.roleList.includes("S2")) && (
              <GroupItem cssClass={"RA"}>
                {projectAssign.roleList.includes("D") && (
                  <SimpleItem
                    dataField={"D"}
                    editorType={"dxTagBox"}
                    editorOptions={{
                      dataSource: dataSource.DDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignRA,
                      itemRender: itemRender,
                      onValueChanged: onDValueChanged,
                    }}
                  >
                    <Label text={"D"} alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("M") && (
                  <SimpleItem
                    dataField={"M"}
                    editorType={"dxTagBox"}
                    editorOptions={{
                      dataSource: dataSource.MDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignRA,
                      itemRender: itemRender,
                      onValueChanged: onMValueChanged,
                    }}
                  >
                    <Label text={"M"} alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("S1") && (
                  <SimpleItem
                    dataField={"S1"}
                    editorType={"dxTagBox"}
                    editorOptions={{
                      dataSource: dataSource.S1DataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignRA,
                      itemRender: itemRender,
                      onValueChanged: onS1ValueChanged,
                    }}
                  >
                    <Label text={"S1"} alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("S2") && (
                  <SimpleItem
                    dataField={"S2"}
                    editorType={"dxTagBox"}
                    editorOptions={{
                      dataSource: dataSource.S2DataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignRA,
                      itemRender: itemRender,
                      onValueChanged: onS2ValueChanged,
                    }}
                  >
                    <Label text={"S2"} alignment={"right"} />
                  </SimpleItem>
                )}
                {projectAssign.roleList.includes("J") && (
                  <SimpleItem
                    dataField={"J"}
                    editorType={"dxTagBox"}
                    editorOptions={{
                      dataSource: dataSource.JDataSource,
                      valueExpr: "employeeNo",
                      searchEnabled: true,
                      grouped: true,
                      displayExpr: displayExpr,
                      showSelectionControls: true,
                      showClearButton: true,
                      applyValueMode: "useButtons",
                      readOnly:
                        !canAssignRA,
                      itemRender: itemRender,
                      onValueChanged: onJValueChanged,
                    }}
                  >
                    <Label text={"J"} alignment={"right"} />
                  </SimpleItem>
                )}
              </GroupItem>
            )}
          </Form>
        )}
        {projectAssign && projectAssign.roleList?.length === 0 && (
          <p>No roles available for assignment.</p>
        )}
      </div>
    </React.Fragment>
  );
}
